import React from 'react';
import { TableCell } from '@mui/material';

export default function MyTableZeroPCell({ children, ...props }) {
  return (
    <TableCell {...props} sx={{ padding: 0, ...props.sx }}>
      {children}
    </TableCell>
  );
}
